import types from './actionTypes';

const initialState = {
  discountCodes: [],
  validatedDiscount: null,
  loading: false,
  error: null,
  message: null,
};

const discountCodesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DISCOUNT_STATE:
      return initialState;

    case types.RESET_DISCOUNT_MESSAGE:
      return {
        ...state,
        message: null,
        error: null,
      };

    // Validate discount code
    case types.VALIDATE_DISCOUNT_CODE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        validatedDiscount: null,
      };

    case types.VALIDATE_DISCOUNT_CODE.SUCCESS:
      return {
        ...state,
        loading: false,
        validatedDiscount: action.discountData,
        error: null,
      };

    case types.VALIDATE_DISCOUNT_CODE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        validatedDiscount: null,
      };

    // Apply discount code
    case types.APPLY_DISCOUNT_CODE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.APPLY_DISCOUNT_CODE.SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
        error: null,
      };

    case types.APPLY_DISCOUNT_CODE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Fetch discount codes
    case types.FETCH_DISCOUNT_CODES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_DISCOUNT_CODES.SUCCESS:
      return {
        ...state,
        loading: false,
        discountCodes: action.discountCodes,
        error: null,
      };

    case types.FETCH_DISCOUNT_CODES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Create discount code
    case types.CREATE_DISCOUNT_CODE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CREATE_DISCOUNT_CODE.SUCCESS:
      return {
        ...state,
        loading: false,
        discountCodes: [action.discountCode, ...state.discountCodes],
        message: action.message,
        error: null,
      };

    case types.CREATE_DISCOUNT_CODE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Update discount code
    case types.UPDATE_DISCOUNT_CODE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_DISCOUNT_CODE.SUCCESS:
      return {
        ...state,
        loading: false,
        discountCodes: state.discountCodes.map(code =>
          code.id === action.discountCode.id ? action.discountCode : code
        ),
        message: action.message,
        error: null,
      };

    case types.UPDATE_DISCOUNT_CODE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Delete discount code
    case types.DELETE_DISCOUNT_CODE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DELETE_DISCOUNT_CODE.SUCCESS:
      return {
        ...state,
        loading: false,
        discountCodes: state.discountCodes.filter(code => code.id !== action.id),
        message: action.message,
        error: null,
      };

    case types.DELETE_DISCOUNT_CODE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default discountCodesReducer;